export default "__VITE_ASSET__07772a00__"